export default __webpack_public_path__ + "static/media/CsDept.152673c0.png";